module.exports = __webpack_public_path__ + "static/media/color.40e6f5e7.svg";